/**
 *  KeywordSelectorItem script file
**/

import googleAdsService, { KEYWORD_LEVELS } from '@/api/googleAdsService'
import i18n from '@/i18n'
import { MODULE_NAME as MODULE_NAME_KEYWORDS, MUTATIONS as MUTATIONS_KEYWORDS } from '@/store/keywords'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'KeywordSelectorItem',
  mixins: [],
  components: {
    KeywordSelectorItem: () => import('@/components/keyword-selector-item/KeywordSelectorItem.vue')
  },
  props: {
    level: {
      type: String,
      default: KEYWORD_LEVELS[0]
    },
    label: {
      type: String,
      default: i18n.t('CATEGORIES')
    },
    id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState(MODULE_NAME_KEYWORDS, ['childrenMap', 'selectedMap']),
    nextLevel () {
      const nextIndex = KEYWORD_LEVELS.indexOf(this.level) + 1
      return KEYWORD_LEVELS[nextIndex]
    },
    treeKey () {
      return `${this.level}-${this.id}`
    },
    children () {
      return this.childrenMap[this.treeKey] || []
    },
    selected () {
      return this.selectedMap[this.treeKey] || false
    },
    isKeyword () {
      return !this.nextLevel
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME_KEYWORDS, Object.values(MUTATIONS_KEYWORDS)),
    toggleSelect () {
      this[MUTATIONS_KEYWORDS.SET_SELECTED]({
        key: this.treeKey,
        flag: !this.selected
      })
    },
    onToggleOpen () {
      if (!this.children.length) {
        this.fetchChildren()
      }
    },
    async fetchChildren () {
      this.loading = true
      try {
        const children = await googleAdsService.getKeywords(this.level, this.id)
        this[MUTATIONS_KEYWORDS.SET_CHILDREN]({
          key: this.treeKey,
          children
        })
      } catch (err) {
        // eslint-disable-next-line
        console.error('[keyword-selector-item.js] Error fetching keyword children', err)
      }
      this.loading = false
    }
  }
}
